export function ManagedPageIntro({ body }: { body: string }) {
  if (!body.trim()) return null;
  return (
    <section className="mx-auto max-w-5xl px-6 pt-14">
      <div className="rounded-[1.5rem] border-l-4 border-[#185adb] bg-[#f1f6fb] p-7 text-lg leading-8 text-[#52677d] sm:p-9">
        {body.split(/\n\s*\n/).filter(Boolean).map((paragraph, index) => <p key={index} className={index ? "mt-4" : ""}>{paragraph}</p>)}
      </div>
    </section>
  );
}
